(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["village-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('.village-gallery-swiper');
  if(!root) return;
  var wrap=root.querySelector('.swiper-wrapper');
  var maxPerView=4,minSlides=2*maxPerView+2;
  var slides=wrap?Array.from(wrap.children):[];
  if(slides.length&&slides.length<minSlides){
    var i=0;
    while(wrap.children.length<minSlides){
      var clone=slides[i%slides.length].cloneNode(true);
      wrap.appendChild(clone);
      i++;
    }
  }

  var s=new Swiper('.village-gallery-swiper',{
    loop:true,
    loopPreventsSliding:false,
    loopedSlides:100,
    loopedSlidesLimit:false,
    slidesPerView:4,
    spaceBetween:8,
    speed:2000,
    allowTouchMove:false,
    simulateTouch:false,
    freeMode:false,
    autoplay:{delay:1,disableOnInteraction:false,pauseOnMouseEnter:false,stopOnLastSlide:false},
    preloadImages:true,
    updateOnImagesReady:true,
    observer:true,
    observeParents:true,
    preventClicks:false,
    preventClicksPropagation:false,
    breakpoints:{
      0:{slidesPerView:1},
      768:{slidesPerView:2},
      1024:{slidesPerView:3},
      1280:{slidesPerView:4}
    }
  });

  function kick(){ if(!s.autoplay.running){s.autoplay.start();} }
  document.addEventListener('visibilitychange',function(){ if(!document.hidden){ setTimeout(kick,120); }});
  window.addEventListener('focus',function(){ setTimeout(kick,120); });
  setInterval(kick,5000);

  var rafId=null,lastT=0,pxPerMs=wrap.clientWidth/2000000;
  function startTicker(){
    stopTicker();
    s.setTransition(0);
    lastT=performance.now();
    function step(t){
      var dt=t-lastT; lastT=t;
      var cur=s.getTranslate ? s.getTranslate() : s.translate;
      s.setTranslate(cur - dt*pxPerMs);
      rafId=requestAnimationFrame(step);
    }
    rafId=requestAnimationFrame(step);
  }
  function stopTicker(){
    if(rafId){ cancelAnimationFrame(rafId); rafId=null; }
  }

  if(window.Fancybox&&Fancybox.bind){
    Fancybox.bind('[data-fancybox="village-gallery"]',{
      on:{
        init:()=>{ s.autoplay.stop(); startTicker(); },
        reveal:()=>{ s.autoplay.stop(); },
        closing:()=>{ stopTicker(); s.setTransition(0); },
        destroy:()=>{ stopTicker(); s.setTransition(0); s.autoplay.start(); }
      }
    });
  }else if(window.jQuery&&jQuery.fancybox){
    jQuery('[data-fancybox="village-gallery"]').fancybox({
      beforeShow:function(){ s.autoplay.stop(); startTicker(); },
      afterClose:function(){ stopTicker(); s.autoplay.start(); }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
